// ============================================================================
//  savedCourts — magazyn zapisanych konfiguracji na localStorage.
//  Storage wstrzykiwany (testy na atrapie); każdy dostęp w try/catch — tryb
//  prywatny Safari / brak storage degraduje funkcję cicho (list → [],
//  save → null), aplikacja działa dalej bez zapisów.
// ============================================================================

const KEY = 'hnc:savedCourts'
const LIMIT = 20

export function createSavedCourts(storage) {
  const read = () => {
    try {
      const arr = JSON.parse(storage.getItem(KEY) ?? '[]')
      return Array.isArray(arr) ? arr : []
    } catch {
      return []
    }
  }
  const write = (arr) => {
    try {
      storage.setItem(KEY, JSON.stringify(arr))
      return true
    } catch {
      return false
    }
  }
  return {
    list: () => read(),
    // Zwraca wpis (nowy lub istniejący przy deduplikacji szczytu) albo null,
    // gdy zapis się nie powiódł.
    save(cfg) {
      const arr = read()
      if (arr[0] && JSON.stringify(arr[0].cfg) === JSON.stringify(cfg)) return arr[0]
      const entry = { id: crypto.randomUUID(), savedAt: new Date().toISOString(), cfg }
      return write([entry, ...arr].slice(0, LIMIT)) ? entry : null
    },
    remove(id) {
      write(read().filter((e) => e.id !== id))
    },
  }
}

// localStorage z sondą dostępności — null, gdy przeglądarka go blokuje.
export function defaultStorage() {
  try {
    const s = window.localStorage
    s.getItem(KEY)
    return s
  } catch {
    return null
  }
}
